import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

// Paintbrush Outdoors dark theme for the PHA map (instrument gold, quiet chrome).
// Components/directives are registered explicitly because this project uses
// vue-cli (webpack) without webpack-plugin-vuetify auto-import; without this,
// <v-app>/<v-icon>/<v-btn> don't resolve and render as raw unstyled text.
export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'phaDark',
    themes: {
      phaDark: {
        dark: true,
        colors: {
          background: '#0c0e10',
          surface: '#12161a',
          'surface-bright': '#1c2428',
          primary: '#c4b48a',
          'primary-darken-1': '#a89870',
          secondary: '#7dba8a',
          'secondary-darken-1': '#5f9a6c',
          accent: '#c4b48a',
          info: '#8b948c',
          success: '#7dba8a',
          warning: '#c4b48a',
          error: '#ff5d73',
          'on-background': '#e8ece8',
          'on-surface': '#e8ece8',
          'on-primary': '#0c0e10',
          'on-secondary': '#0c0e10',
        },
        variables: {
          'border-color': '#ffffff',
          'theme-on-surface-variant': '#a7a7b4',
        },
      },
    },
  },
})
